import { MODULES } from "../../config/modules.config";

const navConfig = MODULES.filter((m) => m.showInNav !== false).map((m) => {
  if (m.children) {
    return {
      type: "group",
      id: `${m.id}-group`,
      label: m.label,
      icon: m.icon,
      children: m.children.map((c) => ({
        id: c.id,
        label: c.label,
        path: c.path,
        role: c.role,
      })),
    };
  }

  return {
    type: "link",
    id: m.id,
    label: m.label,
    path: m.path,
    role: m.role,
    icon: m.icon,
  };
});

export default navConfig;
